import type { MenuConfig } from '~typings/menu'

import permisosCxP, { RESOURCE_CXP } from '@/auth/permissions/modules/cxp'
import * as names from '@routes/cxp/nombres/transacciones'

const { transacciones } = permisosCxP

export default [
    {
        title: 'cuentas_x_pagar.subopciones.anticipos',
        resource: RESOURCE_CXP,
        action: transacciones.anticipos._perm,
        children: [
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_anticipos',
                route: names.ROUTE_BANDEJA_ANTICIPOS,
                resource: RESOURCE_CXP,
                action: transacciones.anticipos.bandejaAnticipos,
            },
            {
                title: 'cuentas_x_pagar.subopciones.crear_anticipo',
                route: names.ROUTE_CREAR_ANTICIPO,
                resource: RESOURCE_CXP,
                action: transacciones.anticipos.crearAnticipo,
            },
            {
                title: 'cuentas_x_pagar.subopciones.aprobar_anticipos',
                route: names.ROUTE_APROBACION_ANTICIPOS,
                resource: RESOURCE_CXP,
                action: transacciones.anticipos.aprobacionAnticipos,
            },
        ],
    },
    {
        title: 'cuentas_x_pagar.subopciones.reembolsos',
        resource: RESOURCE_CXP,
        action: transacciones.reembolsos._perm,
        children: [
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_reembolso_interno',
                route: names.ROUTE_BANDEJA_REEMBOLSO_INTERNO,
                resource: RESOURCE_CXP,
                action: transacciones.reembolsos.bandejaReembolsoInterno,
            },
            {
                title: 'cuentas_x_pagar.subopciones.reembolso_interno',
                route: names.ROUTE_REEMBOLSO_INTERNO,
                resource: RESOURCE_CXP,
                action: transacciones.reembolsos.reembolsoInterno,
            },
            {
                title: 'cuentas_x_pagar.subopciones.aprobacion_reembolso_interno',
                route: names.ROUTE_APROBACION_REEMBOLSO_INTERNO,
                resource: RESOURCE_CXP,
                action: transacciones.reembolsos.aprobacionReembolsoInterno,
            },
        ],
    },
    {
        title: 'cuentas_x_pagar.subopciones.ordenes_pago',
        resource: RESOURCE_CXP,
        action: transacciones.ordenesPago._perm,
        children: [
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_orden_pago',
                route: names.ROUTE_BANDEJA_ORDEN_PAGO,
                resource: RESOURCE_CXP,
                action: transacciones.ordenesPago.bandejaOrdenPago,
            },
            {
                title: 'cuentas_x_pagar.subopciones.orden_pago',
                route: names.ROUTE_ORDEN_PAGO_SIN_FLUJO,
                resource: RESOURCE_CXP,
                action: transacciones.ordenesPago.ordenPagoSinFlujo,
            },
        ],
    },
    {
        title: 'cuentas_x_pagar.subopciones.registro_documento',
        resource: RESOURCE_CXP,
        action: transacciones.registroDocumentos._perm,
        children: [
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_registro_documento',
                route: names.ROUTE_BANDEJA_REGISTRO_DOCUMENTO,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.bandejaRegistroDocumento,
            },
            {
                title: 'cuentas_x_pagar.subopciones.registro_documento',
                route: names.ROUTE_REGISTRO_DOCUMENTO,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.registroDocumento,
            },
            {
                title: 'cuentas_x_pagar.subopciones.aprobacion_registro_documento',
                route: names.ROUTE_APROBACION_REGISTRO_DOCUMENTO,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.aprobacionRegistroDocumento,
            },
            {
                title: 'cuentas_x_pagar.subopciones.asignacion_oe',
                route: names.ROUTE_ASIGNACION_ORDEN_ENTREGA,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.asignacionOrdenEntrega,
            },
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_gastos_importacion',
                route: names.ROUTE_BANDEJA_GASTOS_IMPORTACIONES_POR_REGISTRAR,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.importacionesPendientes,
            },
            {
                title: 'cuentas_x_pagar.subopciones.aprobacion_cruce_regdoc',
                route: names.ROUTE_APROBACION_CRUCE_REGDOC,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.aprobacionCruceRegdoc,
            },
            {
                title: 'cuentas_x_pagar.subopciones.asignacion_tareas',
                route: names.ROUTE_ASIGNACION_TAREAS,
                resource: RESOURCE_CXP,
                action: transacciones.registroDocumentos.asignacionTareas,
            },
        ],
    },
    {
        title: 'cuentas_x_pagar.subopciones.abonos',
        resource: RESOURCE_CXP,
        action: transacciones.abonos._perm,
        children: [
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_abonos',
                route: names.ROUTE_BANDEJA_ABONOS,
                resource: RESOURCE_CXP,
                action: transacciones.abonos.bandejaAbonos,
            },
            {
                title: 'cuentas_x_pagar.subopciones.abono',
                route: names.ROUTE_CREAR_ABONO,
                resource: RESOURCE_CXP,
                action: transacciones.abonos.crearAbono,
            },
        ],
    },
    {
        title: 'cuentas_x_pagar.subopciones.notas_credito',
        resource: RESOURCE_CXP,
        action: transacciones.notasCredito._perm,
        children: [
            {
                title: 'cuentas_x_pagar.subopciones.bandeja_nota_credito',
                route: names.ROUTE_BANDEJA_NOTA_CREDITO,
                resource: RESOURCE_CXP,
                action: transacciones.notasCredito.bandejaNotaCredito,
            },
            {
                title: 'cuentas_x_pagar.subopciones.nota_credito',
                route: names.ROUTE_NOTA_CREDITO,
                resource: RESOURCE_CXP,
                action: transacciones.notasCredito.notaCredito,
            },
        ],
    },
    {
        title: 'cuentas_x_pagar.subopciones.liquidacion_embarques',
        route: names.ROUTE_LIQUIDACION_EMBARQUES,
        resource: RESOURCE_CXP,
        action: transacciones.liquidacionEmbarques,
    },
    {
        title: 'cuentas_x_pagar.subopciones.bandeja_liquidacion_compra_servicios',
        route: names.ROUTE_BANDEJA_LIQUIDACION_COMPRA_SERVICIO,
        resource: RESOURCE_CXP,
        action: transacciones.liquidacionCompraServicio,
    },
    {
        title: 'cuentas_x_pagar.subopciones.liquidacion_compra_servicios',
        route: names.ROUTE_LIQUIDACION_COMPRA_SERVICIO,
        resource: RESOURCE_CXP,
        action: transacciones.liquidacionCompraServicio,
    },
] as MenuConfig[]
